module.exports = __webpack_public_path__ + "img/brown leather bifold wallet on gray concrete floor.62aae108.png";